module.exports = __webpack_public_path__ + "img/profile_default.b228b14b.png";